import html2canvas from "html2canvas";
import BgPattern from "../components/BgPattern";
import ConfettiBG from "../components/ConfettiBg";
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Logo from "../components/Logo";

function ViewMessage() {
	const elem = useRef();
	const [message, setmessage] = useState("");
	const location = useLocation();
	const navigate = useNavigate();

	useEffect(() => {
		try {
			if (location.state.message) {
				setmessage(location.state.message);
			} else {
				navigate(-1, { replace: true });
			}
		} catch (e) {
			navigate(-1, { replace: true });
		}

		return () => {};
	}, []);

	const convertDivToJPEG = async (divElement, fileName = "output") => {
		if (!divElement) {
			console.error(`Element with id "${divElement}" not found.`);
			return;
		}

		try {
			const canvas = await html2canvas(divElement, { scale: 2 });
			const dataURL = canvas.toDataURL("image/jpeg");

			// Create a temporary link element
			const link = document.createElement("a");
			link.href = dataURL;
			link.download = `${fileName}.jpg`;

			// Trigger a click event to simulate a download
			link.click();
		} catch (error) {
			console.error("Error converting div to JPEG:", error);
		}
	};

	return (
		<div ref={elem} className="fixed flex-col z-10 box-border top-0 left-0 w-full h-full p-6  bg-black bg-opacity-50 flex items-center justify-center">
			<BgPattern rotate className="bg-[#0b0022] absolute h-full w-full z[-1]"></BgPattern>
			<ConfettiBG></ConfettiBG>
			<div className="bg-[#5e3092] shadow-lg relative z-10 w-full min-h-[250px] max-w-[600px] max-h-[80vh]  rounded-lg overflow-hidden flex flex-col items-center justify-center">
				<div className="w-full h-[60px] relative box-border z-20 flex justify-center items-center" style={{ background: "linear-gradient(73deg, rgba(0,153,255,1) 0%, rgba(160,0,255,1) 100%)" }}>
					<p className="text-white h-full flex items-center justify-center text-xl font-bold w-full text-center">TellMeBefore24</p>
				</div>
				<div className=" bg-[#322456] w-full flex flex-col break-words box-border p-2 rounded-md mx-2  text-center text-white h-full sm:text-md md:text-lg font-semibold">{message}</div>
			</div>
			<button
				onClick={() => {
					convertDivToJPEG(elem.current, new Date().getTime());
				}}
				className=" z-20 text-white px-4 py-2 mt-4 rounded-[100px] outline-none active:border-1"
				style={{ background: "linear-gradient(73deg, rgba(0,153,255,1) 0%, rgba(160,0,255,1) 100%)" }}
			>
				Download Image
			</button>
			<Logo className="absolute bottom-2 z-50"></Logo>
		</div>
	);
}

export default ViewMessage;
